import { render, staticRenderFns } from "./QuickItemSideMenu.vue?vue&type=template&id=16d19fea"
import script from "./QuickItemSideMenu.vue?vue&type=script&lang=js"
export * from "./QuickItemSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports